import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=6f3b29d4&scoped=true&"
import script from "./packageList.vue?vue&type=script&lang=js&"
export * from "./packageList.vue?vue&type=script&lang=js&"
import style0 from "./packageList.vue?vue&type=style&index=0&id=6f3b29d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b29d4",
  null
  
)

export default component.exports